<template>
  <!-- <div class="base_box" @click.prevent="$refs.moreinfoRef.hide()"> -->
  <div class="base_box">
    <!-- 左侧信息列表 -->
    <AllInfo ref="moreinfoRef" :info="clickInfo"> </AllInfo>
    <Search @toSearch="toSearch"> </Search>
    <div>
      <div class="list_box roll animated fadeIn">
        <div class="list_card card animated flipInY" v-for="(item,i) in templeDate" :key="i">
          <div class="list_title">{{item.name}}</div>

          <div class="card">
            <div class="img_box">
              <img :src="item.picture?  (imgUrl + item.picture.split('#')[0]):(imgUrl +common.baseImg())" />
            </div>
          </div>

          <div class="list_table card">
            <table>
              <tr>
                <th>{{$t("list.year")}}:</th>
                <td>{{item.years}}({{item.dynasty}})</td>
              </tr>
              <tr>
                <th>{{$t("list.address")}}:</th>
                <td>{{item.address}}</td>
              </tr>
              <tr>
                <th>{{$t("list.father")}}:</th>
                <td>{{item.father_name}}</td>
              </tr>

              <!-- <tr>
                <th>描述:</th>
                <td>{{item.description}}</td>
              </tr> -->
            </table>

            <div class="more_info" @click.stop="getInfo(item)">{{$t("list.more")}}</div>

            <el-tooltip effect="light" :content='$t("list.hits")' placement="top-start">
              <div class="count"> <i class="el-icon-view"></i>{{item.count}}</div>

            </el-tooltip>

          </div>
          <div class="list_body"></div>
        </div>
      </div>
      <div class="page_box card animated slideInUp roll">
        <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :pager-count="5" :current-page="pageItem.page" :page-sizes="[50, 200, 300, 500]" :page-size="pageItem.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="templeNum">
        </el-pagination>
      </div>
      <div class="page_box_mobile  card animated slideInUp roll">
        <el-pagination small @size-change="pageSizeChange" @current-change="pageChange" :pager-count="5" :current-page="pageItem.page" :page-sizes="[50, 200, 300, 500]" :page-size="pageItem.pageSize" layout="sizes, prev, pager, next" :total="templeNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AllInfo from "../../components/AllInfo.vue";
import Search from "../../components/Search.vue";
import ImgList from "../../components/ImgList.vue";
export default {
  components: {
    AllInfo,
    Search,
    ImgList,
  },
  name: "Map",
  data() {
    return {
      templeDate: null,
      imgUrl: "",
      templeNum: 0,
      pageItem: {
        page: 1,
        pageSize: 50,
        name: "",
      },
      clickInfo: {}, //当前点击的庙宇信息
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getTempleList();
    this.imgUrl = this.common.imgUrl();
  },
  methods: {
    // 切换页数
    pageSizeChange(num) {
      this.pageItem.pageSize = num;
      this.getTempleList();
    },
    //切换每页数量
    pageChange(num) {
      this.pageItem.page = num;
      this.getTempleList();
    },

    //获取分页庙宇列表
    getTempleList() {
      let pardata = {
        page: this.pageItem.page.toString(),
        pageSize: this.pageItem.pageSize.toString(),
        name: this.pageItem.name,
        state: "1",
      };
      this.$Loading.show();
      this.http.post("temple/getTempleListPage", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          this.templeDate = res.data.records;
          this.templeNum = res.data.total;
          this.$message({
            // 获取庙宇信息成功
            message: this.$t("list.s1"),
            type: "success",
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    toSearch(data) {
      this.pageItem.name = data;
      this.pageItem.page = 1;
      this.getTempleList();
    },
    //查看信息
    getInfo(item) {
      this.clickInfo = item; //当前点击的庙宇信息
      this.$refs.moreinfoRef.show();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.base_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-top: $head-height;
  box-sizing: border-box;
  background: url("../../assets/img/banner.jpg") no-repeat fixed center;
  background-size: auto 100%;
  .list_box {
    border: $b-glass;
    border-radius: $r-mid;
    width: 90%;
    margin: $m-lit auto;
    height: calc(100vh - $head-height - 9rem);
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    .list_card {
      // width: 20%;
      width: 16rem;
      margin: $m-lit;
      padding: $m-lit;
      //玻璃质感
      // background-color: $c-glass;
      // backdrop-filter: $d-glass;
      border: $b-glass;

      .list_title {
        color: $c-main;
        font-size: $f-mid;
        white-space: nowrap;
        overflow: hidden; //内容超出隐藏
        text-overflow: ellipsis;
      }
      .img_box {
        width: 100%;
        height: 10rem;
        overflow: hidden;
        border-radius: $r-mid;
        img {
          // width: 100%;
          // height: auto;
          width: auto;
          min-width: 100%;
          height: 100%;
        }
      }
      .list_table {
        width: 15rem;
        margin: $m-lit auto;
        padding: $m-lit;

        table {
          color: $c-text-main;
          width: 100%;
          text-align: left;
          max-height: 10rem;
          overflow: hidden;
          height: 6rem;
          border-collapse: collapse;
          // white-space: nowrap;
          //    overflow: hidden; //内容超出隐藏
          //  text-overflow: ellipsis;
          tr {
            height: 2rem;
          }

          th {
            width: 4rem;
          }

          td {
            border-bottom: 1px solid $c-main-light;

            text-overflow: -o-ellipais-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .more_info {
          border: $b-border;
          // width: 5rem;
          padding: 0 0.4rem;
          color: $c-main;
          border-radius: $m-min;
          text-align: center;
          margin: $m-lit;
          margin-bottom: 0;
          box-shadow: $shadow;
          cursor: default;
          display: inline-block;
          font-size: 12px;
        }
        .count {
          display: inline-block;
          float: right;
          margin: $m-lit;
          font-size: $f-mid;
          cursor: default;
          color: $c-text-main;
          i {
            margin-right: $m-lit;
            font-size: $f-big;
            color: $c-second;
          }
        }
      }
    }
  }
}
.page_box {
  width: 90%;
  margin: 0 auto;
  margin-top: $m-lit;
  padding: $m-lit;

  // color: $c-main;
}
.page_box_mobile {
  display: none;
}

@media screen and (min-width: 451px) and (max-width: 650px) {
  .base_box {
    .list_box {
      .list_card {
        width: 14rem;
        .img_box {
          height: 7rem;
        }
        .list_table {
          width: 13rem;
        }
      }
    }
  }
  .page_box {
    overflow: hidden;
    overflow-x: auto;
  }
}

@media screen and (max-width: 450px) {
  .base_box {
    .list_box {
      .list_card {
        width: 45%;
        .img_box {
          height: 7rem;
        }
        .list_table {
          font-size: 12px;
          width: 100%;
        }
      }
    }
  }

  .page_box {
    display: none;
  }
  .page_box_mobile {
    display: block;
    width: 90%;
    margin: 0 auto;
    margin-top: $m-lit;
    padding: $m-lit;
    font-size: $f-lit;
  }
}
</style>